<template>
    <div class="row">
        <div class="col-12">
            <div v-if="asientos.length == 0">
                <div v-if="alguno_seleccionado && forzar_adyacentes" class="alert alert-warning">
                    {{ $t("partido.error_butacas") }}
                </div>
            </div>
            <template v-else>
                <template v-if="modo == 'normal'">
                    <label v-if="event && !event.reserva_instalaciones">{{  $t("partido.tus_asientos") }}</label>
                    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                        <template v-for="(asiento, index) in asientos" class="mb-3">
                            <div class="lightgray-content p-2 mb-2" :key="index">
                                <div class="text-bold mb-2 d-md-flex">
                                    <div class="oswald">
                                        {{ (num = index + 1) }}. {{ asiento.asiento.zona_nombre }}
                                    </div>
                                    <div class="ml-2">
                                        <small v-if="asiento.asiento.fila">
                                            {{ $t("general.fila") }}: {{ asiento.asiento.fila }}
                                        </small>
                                        <small v-if="asiento.asiento.asiento">
                                            {{ $t("general.butaca") }}: {{ asiento.asiento.asiento }}
                                        </small>
                                    </div>
                                </div>

                                <div class="form-group mb-1">
                                    <template v-if="index > 0 && Array.isArray(precios_acompanante)">
                                        <ValidationProvider :name="'precio' + index" rules="required" v-slot="{ errors }">
                                            <b-row class="align-items-center">
                                                <b-col :cols="tiene_asiento_y_info(asiento) ? '11' : '12'" :class="tiene_asiento_y_info(asiento) ? 'pr-2' : 'pr-3'">
                                                    <select 
                                                        name="precio"
                                                        :id="'precios_' + index" 
                                                        v-model="asiento.asiento.event_ticket_id" 
                                                        :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                                        :disabled="!puedo_cambiar"
                                                        @change="cambiarInfo(asiento.asiento.event_ticket_id, asiento)"
                                                    >
                                                        <option value="" selected="selected" hidden>
                                                            {{ $t("partido.tipo_entrada") }}
                                                        </option>
                                                        <template v-for="(precio_a, index) in precios_acompanante">
                                                            <option :key="index" :value="precio_a.id">
                                                                {{ precio_a.descripcion }} / {{ precio_a.precio | formatear_precio }}
                                                            </option>
                                                        </template>
                                                    </select>
                                                </b-col>
                                                <b-col v-if="tiene_asiento_y_info(asiento)" cols="1" class="p-0">
                                                    <Button class="p-0 border-0 bg-transparent" type="button" name="tooltip" v-b-tooltip.hover.right :title="asiento.precio.informacion">
                                                        <i class="fas fa-info-circle black" style="font-size: 17px;"></i>
                                                    </Button>
                                                </b-col>
                                            </b-row>
                                        </ValidationProvider>
                                    </template>
                                    <template v-else>
                                        <ValidationProvider :name="'precio' + index" rules="required" v-slot="{ errors }">
                                            <b-row class="align-items-center">
                                                <b-col :cols="tiene_asiento_y_info(asiento) ? '11' : '12'" :class="tiene_asiento_y_info(asiento) ? 'pr-2' : 'pr-3'">
                                                    <select 
                                                        name="precio"
                                                        id="precios" 
                                                        v-model="asiento.asiento.event_ticket_id" 
                                                        :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                                        :disabled="!puedo_cambiar"
                                                        @change="cambiarInfo(asiento.asiento.event_ticket_id, asiento)"
                                                    >
                                                        <option value="" selected="selected" hidden>
                                                            {{ $t("partido.tipo_entrada") }}
                                                        </option>
                                                        <template v-for="(precio, index) in precios">
                                                            <option :key="index" :value="precio.id">
                                                                {{ precio.descripcion }} / {{ precio.precio | formatear_precio }}
                                                            </option>
                                                        </template>
                                                    </select>
                                                </b-col>
                                                <b-col v-if="tiene_asiento_y_info(asiento)" cols="1" class="p-0">
                                                    <Button class="p-0 border-0 bg-transparent" type="button" name="tooltip" v-b-tooltip.hover.right :title="asiento.precio.informacion">
                                                        <i class="fas fa-info-circle black" style="font-size: 17px;"></i>
                                                    </Button>
                                                </b-col>
                                            </b-row>
                                        </ValidationProvider>
                                    </template>
                                </div>
                            </div>
                        </template>
                        <div class="d-flex">
                            <template v-if="show_continuar && (asientos_validos == undefined || asientos_validos) && !teatro.carrito_varios_eventos">
                                <ContentOrLoading>
                                    <button
                                        v-if="! loading"
                                        :class="['button', 'large-button', 'responsive', { 'effect-button': this.puedo_continuar}]" 
                                        type="submit"
                                        :disabled=" !this.puedo_continuar || loading"
                                    >
                                        <span>{{ $t('partido.continuar_compra') }}</span>
                                    </button>
                                </ContentOrLoading>
                                
                            </template>
                            <div v-if="teatro.carrito_varios_eventos" class="w-100">
                                <b-row no-gutters class="align-items-center">
                                    <template v-if="!carrito || carrito.items_count == 0">
                                        <b-col cols="12" sm="8" md="8" class="pr-3" v-if="show_continuar" >
                                            <ContentOrLoading>
                                                <button 
                                                    v-if="! loading" 
                                                    :class="['button', 'btn', 'btn-block', 'responsive', { 'effect-button': this.puedo_continuar }]" 
                                                    type="submit"
                                                    :disabled="!this.puedo_continuar || loading"
                                                >
                                                    <span>{{ $t('partido.continuar_compra') }}</span>
                                                </button>
                                            </ContentOrLoading>
                                        </b-col>

                                        <b-col cols="12" sm="4" md="4" class="pt-2 pr-3 pr-sm-0 pt-sm-0 text-center" v-if="! loading">
                                            <b-button
                                                data-cy="add-cart"
                                                v-if="show_continuar"
                                                :class="['button', 'btn-block']"
                                                :style="{ paddingTop: '0.74rem', paddingBottom: '0.74rem' }"
                                                :disabled="!this.puedo_continuar || loading"
                                                @click="checkCarrito()"
                                            >
                                                <i class="fa fa-cart-plus" aria-hidden="true"></i>
                                            </b-button>
                                        </b-col>
                                    </template>

                                    <template v-else>
                                        <b-col cols="12" class="mb-2">
                                            <b-button
                                                data-cy="add-cart"
                                                v-if="show_continuar"
                                                class="btn btn-block responsive"
                                                :disabled="!this.puedo_continuar || loading"
                                                @click="checkCarrito()"
                                            >
                                                {{ $t('carrito.añadir') }}
                                            </b-button>
                                        </b-col>
                                    </template>
                                </b-row>
                            </div>
                            <template v-else-if="errorAsientos">
                                <h4 class="text-danger">Debes seleccionar mínimo {{ asientos_minimos }} butacas.</h4>
                            </template>
                            <template v-else-if="asientos_validos == false">
                                <h4 class="text-danger">No puedes dejar un hueco entre dos asientos</h4>
                            </template>
                            <button 
                                type="button"
                                :class="['button', 'large-button', 'ml-3', 'responsive', { 'effect-button': puedo_cambiar }]" 
                                v-if="event && event.amigo_abonado && event.lfp_id && puedo_cambiar"
                                :disabled="!asientos_con_precios"
                                @click="handleModoAmigo"
                            >
                                <span>{{ $t('partidos.soy_amigo_abonado', { abonado: teatro.texto_abonado }) }}</span>
                            </button>
                        </div>
                        <div v-if="errorAcompanantes" class="alert alert-danger mt-2">
                            - {{ errorAcompanantes }}
                        </div>
                    </ValidationObserver>
                </template>
                <template v-else>
                    <ValidationObserver tag="form" ref="observer2" @submit.prevent="submitAmigo()">
                        <div class="row">
                            <div class="col-12">
                                <h4>Introduce los datos del abonado:</h4>
                            </div>
                            <div class="col-12 mt-3">
                                <FormInput label="ID abonado" name="id_persona" rules="required" v-model="id_persona" :disabled="!puedo_cambiar" />
                            </div>
                            <div class="col-12 mt-3">
                                <FormInput :label="$t('partidos.lfp_4_cifras')" name="pin" rules="required" v-model="pin" :disabled="!puedo_cambiar" />
                            </div>
                            <div class="col-12 mt-3" v-if="error_message">
                                <div class="alert alert-danger" role="alert">
                                    <template v-if="error_message === 'No existe precio para socios en el área indicada para este partido.'">
                                        <h4>{{ $t("partidos.lfp_error_no_existe_precio") }}</h4>
                                    </template>
                                    <template v-if="error_message === 'Error interno del sistema. Este código corresponde a errores de coherencia internos del sistema de la LFP.'">
                                        <h4>{{ $t("partidos.lfp_error_a_ocurrido_un_error") }}</h4>
                                    </template>
                                    <template v-if="error_message === 'Se ha recibido un código PIN incorrecto.'">
                                        <h4>{{ $t("partidos.lfp_error_pin") }}</h4>
                                        <p>{{ $t("partidos.lfp_error_pin_mensaje") }}</p>
                                    </template>
                                </div>
                            </div>
                            <div class="col-12 mt-3 d-flex">
                                <ContentOrLoading>
                                    <button
                                        v-if="!loading"
                                        :class="['button', 'large-button', 'responsive', { 'effect-button': !puedo_cambiar }]" 
                                        type="submit"
                                        :disabled="!puedo_cambiar"
                                    >
                                        Continuar
                                    </button>
                                </ContentOrLoading>
                                <button 
                                    v-if="!event.solo_abonados"
                                    :class="['button', 'large-button', 'ml-3', 'responsive', { 'effect-button': puedo_cambiar }]" 
                                    @click="volver()"
                                    :disabled="!puedo_cambiar"
                                >
                                    Volver
                                </button>
                            </div>
                        </div>
                    </ValidationObserver>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            "asientos",
            "precios",
            "event",
            "puedo_cambiar",
            "precios_acompanante",
            "forzar_adyacentes",
            "alguno_seleccionado",
            'asientos_minimos',
            'puedo_continuar',
            "asientos_validos",
            "error_message",
            'precios_seleccionados',
            'loading'
        ],
        data() {
            return {
                modo: "normal",
                id_persona: null,
                pin: null,
                asientos_con_precios: false,
                errorAcompanantes: null
            };
        },
        created() {
            if(this.event && this.event.solo_abonados && this.event.lfp_id) {
                this.modo = "amigo";
            }
        },
        computed: {
            footer() {
                return this.$store.getters.getFooter;
            },
            show_continuar() {
                if((this.asientos_minimos && this.asientos.length < this.asientos_minimos)) {
                    return false;
                }
                return true;
            },
            errorAsientos() {
                return !(this.asientos_minimos === undefined || this.asientos.length === this.asientos_minimos);
            },
            teatro(){
                return this.$store.getters.getTeatro;
            },
            carrito() {
                return this.$store.getters.getCarritoActivoOnline;
            },
        },
        watch: {
            asientos() {
                this.errorAcompanantes = null;
                if (this.precios_seleccionados && this.precios_seleccionados.length > 0) {
                    for (let i in this.asientos) {
                        if (!this.asientos[i].asiento.event_ticket_id) {
                            this.asientos[i].asiento.event_ticket_id = this.precios_seleccionados[i];
                        }
                    }
                } else {
                    for (let i = 0; i < this.asientos.length; i++) {
                        if(! this.asientos[i].asiento.event_ticket_id) {
                            if (this.precios && this.precios.length == 1) {
                                if (Array.isArray(this.precios_acompanante) && this.event?.n_acompanantes > 0) {
                                    if (i === 0) {
                                        this.asientos[i].asiento.event_ticket_id = this.precios[0].id;
                                    } else {
                                        this.asientos[i].asiento.event_ticket_id = this.precios_acompanante[0].id;
                                    }
                                } else {
                                    this.asientos[i].asiento.event_ticket_id = this.precios[0].id;
                                }
                            } else {
                                this.asientos[i].asiento.event_ticket_id = "";
                            }
                        } else if (this.teatro.hash === 'K2CEa3vYJOmQJS1gTuxu') {
                            if(! this.asientos[i].asiento.event_ticket_id) {
                                if (this.precios && this.precios.length == 1) {
                                    this.asientos[i].asiento.event_ticket_id = this.precios[0].id;
                                } else {
                                    this.asientos[i].asiento.event_ticket_id = "";
                                }
                            }
                        }
                    }
                }
                this.asientos_con_precios = this.asientos.every(asiento => asiento.asiento.event_ticket_id);
            },
        },
        methods: {
            continuar() {
                for (var i in this.asientos) {
                    for (var j in this.precios) {
                        if (this.precios[j].id == this.asientos[i].asiento.event_ticket_id) {
                            this.asientos[i].precio = this.precios[j];
                            this.asientos[i].precioSeleccionado = this.precios[j];
                            this.asientos[i].precios = this.precios;
                            if (this.asientos[i].asiento) {
                                this.asientos[i].fila = this.asientos[i].asiento.fila;
                                this.asientos[i].butaca = this.asientos[i].asiento.asiento;                            
                            }
                        }
                    }
                    for (var k in this.precios_acompanante) {
                        if (
                            this.precios_acompanante[k].id ==
                            this.asientos[i].asiento.event_ticket_id
                        ) {
                            this.asientos[i].precio = this.precios_acompanante[k];
                            this.asientos[i].precios = this.precios_acompanante;
                        }
                    }

                    this.asientos[i].asiento.id_persona = this.id_persona;
                    this.asientos[i].asiento.pin = this.pin;
                }
                this.$emit("continuar");
            },
            checkCarrito() {
                if (this.carrito) {
                    this.setItemsCarrito();
                } else {
                    this.crearCarrito();
                }
            },
            async crearCarrito() {
                const params = { filters: {}, uuid: localStorage.getItem('uuid') };

                return this.$store.dispatch(this.config.getVuexAlias('usuario.carrito.crear'), params).then(res => {
                    this.setItemsCarrito();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                });
            },
            async setItemsCarrito() {
                this.disableButtonCart = true;
                
                const params = {
                    filters: {uuid: localStorage.getItem('uuid')},
                    cart_id: this.carrito?.id,
                    plazas: [],
                    asientos: this.getAsientosFormatted()
                };

                this.$store.dispatch(this.config.getVuexAlias('usuario.carrito.add-items'), params).then(res => {
                    this.$toast.success('Entradas añadidas al carrito correctamente.');
                    this.$store.dispatch('USUARIO_CARRITO_ACTIVO', {filters:{ uuid: localStorage.getItem('uuid')}});
                    this.$router.push({path: "/eventos"});
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.disableButtonCart = false;
                });
            },
            getAsientosFormatted() {
                let asientosFormateados = [];
                this.asientos.map(asiento => {
                    asientosFormateados.push({
                        precio: {
                            id: asiento.precio.id
                        },
                        units: 1,
                        region_id: asiento.asiento.zona_id,
                        row: asiento.asiento.fila,
                        seat: asiento.asiento.asiento,
                        event_id: this.$route.params.event_id,
                        event_session_id: this.$route.params.sesion_id
                    })
                });
                return asientosFormateados;
            },
            volver() {
                this.modo = "normal";
                this.id_persona = null;
                this.pin = null;
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if (isValid) {
                    this.continuar();
                }
            },
            async submitAmigo() {
                const isValid = await this.$refs.observer2.validate();
                if (isValid) {
                    this.continuar();
                }
            },
            cambiarInfo(precio_id, asiento) {
                var precio = this.precios.find(price => price.id === precio_id);

                if (precio) {
                    asiento.precio = precio;
                }

                this.asientos_con_precios = this.asientos.every(asiento => asiento.asiento.event_ticket_id);
            },
            tiene_asiento_y_info(asiento) {
                if (asiento && asiento.asiento.event_ticket_id && asiento.precio && asiento.precio.informacion) {
                    return true;
                }

                return false;
            },
            handleModoAmigo() {
                const max = this.event?.n_acompanantes
                const min = this.event?.n_acompanantes_min
                const seleccionados = this.asientos?.length || 0

                this.errorAcompanantes = null;

                if (max != null && min != null) {
                    if (seleccionados < min || seleccionados > max) {
                        if (min == max) {
                            this.errorAcompanantes = `Debes seleccionar ${min} acompañante(s).`;
                        } else {
                            this.errorAcompanantes = `Debes seleccionar entre ${min} y ${max} acompañante(s).`;
                        }
                        return
                    }
                }

                this.modo = 'amigo'
            }
        },
    };
</script>

<style>
.responsive {
    min-width: 45px !important;
    font-size: 13px !important;
}
</style>
